import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/services/auth.service';
import { MipsService } from 'src/app/services/Modules/mips.service';
import { ManageMpisService } from './manage-mpis.service';

// const defaultMips = [
//   '47',
//   '110',
//   '155',
//   '293',
//   '386',
//   '126'
// ]
@Component({
  selector: 'app-manage-mips',
  templateUrl: './manage-mips.component.html',
  styleUrls: ['./manage-mips.component.css']
})
export class ManageMipsComponent implements OnInit {

  enabled_mips: Array<string> = [];
  mip_reporting: boolean;
  questions: any = [];
  currentUser: any;
  userMips;

  loadingMipQuestions: any = {};

  originalState:any = {};

  constructor(
    private manageMpisService: ManageMpisService,
    private _authService: AuthService,
    private toaster: ToastrService,
    private mipsService: MipsService,
    private location: Location
  ) {
    this.currentUser = this._authService.currentUser;

  }

  async ngOnInit() {
    this.getMipsReportingsAndMeasures();
    await this.getCompanyMips();
  }

  getMipsReportingsAndMeasures() {
    this.manageMpisService.getMipsReportingsAndMeasures().subscribe((response: any) => {
      console.log(response.data);
      if (response.status === 200) {
        if (response.data.mip_reporting) {
          this.mip_reporting = response.data.mip_reporting;
        }
      }
    });
  }

  getQuestions(measure_number) {
    this.loadingMipQuestions[measure_number] = true;
    let arr = this.questions.filter(element => element.measure_number !== measure_number)
   this.questions = arr;
    this.mipsService.getQuestions(measure_number, null, this.currentUser.company_id).subscribe((response: any) => {
      if (response.status === 200) {
        response.data.array.map(data=> this.questions.push(data));
      }
      // console.log(this.questions);
      this.loadingMipQuestions[measure_number] = false;
    });
    console.log("this.q",this.questions);
  }
  
  changeMips($event) {
    // console.log("th",$event);
    if ($event.checked && !this.enabled_mips.includes($event.source.value)) {
      // if ($event.source.value == "154" || $event.source.value == "155") {
      //   this.enabled_mips.push("154");
      //   this.enabled_mips.push("155");
      //   console.log(this.enabled_mips);
      // }
      // else {
        this.enabled_mips.push($event.source.value);
      // }
    }
    if (!$event.checked) {
      // if ($event.source.value == "154" || $event.source.value == "155") {
      //   this.enabled_mips.splice(this.enabled_mips.indexOf("154"), 1);
      //   this.enabled_mips.splice(this.enabled_mips.indexOf("155"), 1);
      // }
      let arr;
      arr = this.enabled_mips.filter(data => {
        return data !== $event.source.value;
      });
      this.enabled_mips = arr;
      console.log(this.enabled_mips);
    }
    // console.log(this.enabled_mips);

  }
  setEnabledMips() {
    this.manageMpisService.setEnabledMips(this.enabled_mips).subscribe((response: any) => {
      console.log(response.data);
      if (response.status === 200) {
      this.originalState = [...this.enabled_mips];
        this.toaster.success("Updated Measures");
        // this.location.back();
      }
    });
  }
  setMipReporting($event) {
    this.mip_reporting = $event.checked;
    if($event.checked && this.enabled_mips.length < 6) {
      return;
    }
    this.manageMpisService.setMipReporting(this.mip_reporting).subscribe((response: any) => {
      console.log(response.data);
      if (response.status === 200) {
        // this.toaster.success("Updated Reports");
        this.currentUser.mip_reporting = response.data.mip_reporting;
        this.currentUser.enabled_mips = response.data.enabled_mips;
        if (response.data.enabled_mips) {
          this.enabled_mips = response.data.enabled_mips;
        }
        if (response.data.mip_reporting) {
          this.mip_reporting = response.data.mip_reporting;
        }
        
        // if(this.enabled_mips.length === 0) {
        //   this.enabled_mips = [...defaultMips];
        //   this.currentUser.enabled_mips = this.enabled_mips;
          // this.setEnabledMips();
        // }
        // console.log("current ", this.currentUser);
        localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
      }
    });
  }
  setDefault(index, mips_question_id, question, measure_number) {
    this.questions.map((data,i)=>{
      if(data.measure_number === measure_number && data.is_default === true) {
        this.mipsService.updateQuestion(data._id, data.measure_number, data.question, this.currentUser.company_id, false).subscribe((response: any) => {
          console.log(response.data);
          if (response.status === 200) {
            this.questions.splice(i, 1, response.data);
          }
        });
      }
    });
    
    this.mipsService.updateQuestion(mips_question_id, measure_number, question, this.currentUser.company_id, true).subscribe((response: any) => {
      console.log(response.data);
      if (response.status === 200) {
        this.questions.splice(index, 1, response.data);
      }
    });
  }
  async getCompanyMips() {
    let quality_number;
    let res: any = await this.mipsService.getAllMips(this.currentUser.company_id).toPromise();
    if (res.status == 200) {
      quality_number = res.data.array.map(e => {
        return e.quality_number
      })
      this.userMips = res.data.array.map(e => {
        return {measure_number:e.quality_number,measure_name:e.measure_title}
      })
      this.enabled_mips=quality_number;
      this.currentUser.enabled_mips = this.enabled_mips;
      this.originalState = [...this.enabled_mips];
    }
  }
  getMeasures() {
    return this.userMips;
  }

  isValidMips() {
    return this.enabled_mips.length >= 6
  }
  hasMipsChanged() {
    return JSON.stringify(this.originalState.sort()) !== JSON.stringify(this.enabled_mips.sort());
  }
}
